
const useGetPositionById = () => {

  const getPositionById = (e, id) => {
    
    var element = document.getElementById(id).getBoundingClientRect();
    var x = parseInt(e.target.scrollLeft) + element.x + window.scrollX;
    var y = parseInt(e.target.scrollTop) + element.y -3 + window.scrollY;
    return [x,y]
  };

  return getPositionById;
};

export default useGetPositionById;
